// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.txt-error-user{\r\n  padding: 0 12px;\r\n  color: #ff5252 !important;   \r\n  caret-color: #ff5252 !important;\r\n  font-size: 12px;\r\n  position: relative;\r\n  padding-top: 0px !important;\r\n  margin-bottom: 8px !important;\n}\n.row-bg-gray{\r\n  background: gray;\n}\r\n", ""]);
// Exports
module.exports = exports;
